export default __webpack_public_path__ + "static/logo_main-a92b7ed11915029837a9fbf90b25280e.png";